import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=4bef3a24&"
import script from "./Search.jsx?vue&type=script&lang=js&"
export * from "./Search.jsx?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports